/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Set_DatesInputs */

const en_tl_set_dates = /** @type {(inputs: Tl_Set_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set dates`)
};

const de_tl_set_dates = /** @type {(inputs: Tl_Set_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine setzen`)
};

/**
* | output |
* | --- |
* | "Set dates" |
*
* @param {Tl_Set_DatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_set_dates = /** @type {((inputs?: Tl_Set_DatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Set_DatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_set_dates(inputs)
	return en_tl_set_dates(inputs)
});